<template>
  <BootstrapModal :show="showModal"
                  :title="this.mass != null ? 'Messe bearbeiten' : 'Neue Messe anlegen'"
                  :trigger-class=triggerClass :trigger-icon=triggerIcon
                  :trigger-text="triggerText" submit-btn="Speichern" @close="handleClose" @open="handleOpen"
                  @save="handleSave">
    <template v-slot:body>
      <form class="row row-cols-3 g-3">
        <div class="col">
          <label class="form-label" for="datetime">Datum & Uhrzeit</label>
          <input id="datetime" :value="this.mass.datetime && this.mass.datetime.slice(0, 16)" class="form-control"
                 required
                 type="datetime-local"
                 @input="this.mass.datetime = new Date($event.target.value + 'Z').toISOString().slice(0, 16)">
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="incense">Weihrauch?</label>
            <input id="incense" v-model="this.mass.incense" class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <div class="form-check">
            <label class="form-check-label" for="boldTime">Uhrzeit dick?</label>
            <input id="boldTime" v-model="this.mass.boldTime" class="form-check-input" type="checkbox">
          </div>
        </div>
        <div class="col">
          <label class="form-label" for="requiredAltarServers">Anz. Messdiener</label>
          <input id="requiredAltarServers" v-model="this.mass.requiredAltarServers" class="form-control" type="number">
        </div>
        <div class="col">
          <label class="form-label" for="requiredLeaders">Anz. Leiter</label>
          <input id="requiredLeaders" v-model="this.mass.requiredLeaders" class="form-control" type="number">
        </div>
        <div class="col">
          <label class="form-label" for="annotation">Anmerkung</label>
          <input id="annotation" v-model="this.mass.annotation" class="form-control" type="text">
        </div>
      </form>
    </template>
  </BootstrapModal>
</template>

<script>
import BootstrapModal from "@/components/BootstrapModal";
import {useMassStore} from "@/stores/mass";

export default {
  name: "MassCreateEditModal",
  props: ['passInMass', 'triggerIcon', 'triggerText', 'triggerClass'],
  data: function () {
    return {
      mass: {},
      showModal: false
    }
  },
  emits: ['created-mass'],
  methods: {
    handleOpen() {
      this.showModal = true;
      this.mass = this.passInMass == null ? {} : this.passInMass;
    },
    handleClose() {
      this.showModal = false;
      this.mass = {};
    },
    handleSave() {
      if (this.mass.id == null)
        this.massStore.addItem(this.mass);
      else
        this.massStore.updateItem(this.mass);
      this.handleClose();
    },
  },
  components: {BootstrapModal},
  created() {
    if (!this.massStore.loadedData)
      this.massStore.getData();
  },
  setup() {
    const massStore = useMassStore();
    return {massStore};
  }
}
</script>
